module.exports = __webpack_public_path__ + "static/media/ca.fd9513f2.svg";